import { Button, Header, Layout } from '@kanda-libs/ks-design-library';
import { Link } from 'react-router-dom';

import { Content, Footer } from '../components';

import { URLS } from '../../../../config';

interface ViewComponentProps {
  /**
   * Disabled
   */
  disabled?: boolean;
}

const ViewComponent = ({ disabled }: ViewComponentProps) => (
  <Layout
    noBorder
    header={
      <Header.Base
        lines
        options={[
          <Link to={URLS.login} key="back-button">
            <Button.Icon id="forgot-password-mobile-close" icon="close" />
          </Link>,
        ]}
      />
    }
    footer={<Footer disabled={disabled} />}
  >
    <Content />
  </Layout>
);

ViewComponent.displayName = 'ForgotPassword-Request-Mobile-view';

export default ViewComponent;
